import * as React from 'react';
import { usePersonAccountsTAccRoot } from '../../hooks';
import { ActorApiStringDisplay } from '../../../../../../components/display/string';

export const PersonsAccountsTAccRoot = () => {
  const {
    data,
    isLoading,
    error,
  } = usePersonAccountsTAccRoot();
  return (
    <ActorApiStringDisplay
      data={data}
      isLoading={isLoading}
      error={error}
      loadingValue="----"
    />
  );
};
